@if (skeleton()) {
    <lib-skeleton-loader [theme]="{
            'height.px': 20,
            'width.%': 100
    }"></lib-skeleton-loader>
} @else {
    <ul class="flex content-sm-regular leading-[20px] tracking-[-0.0075em]" [style.color]="'var(--'+ colorClass() +')'"
    [ngClass]="{
      'justify-center text-center': position() === 'center',
      'justify-start': position() === 'start',
      'justify-end': position() === 'end',
      'opacity-50': state() === 'disabled',
    }"
    >
        @if (errorMessage) {
            <li>{{ errorMessage | translate }}</li>
        }

        @if (!errorMessage && message()) {
        <li>{{ message() | translate }}</li>
        }
    </ul>
}
